import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../assets/css/cards/card-peoples.module.css';
import images from '../../assets/images';
import Button from '../button/Button';

const CardPeoples = ({ image, name, ocupation, onClick }) => {
    return (
        <>
            <div className={styles.cardPeoples}>
                <img
                    className={styles.cardPeoplesImg}
                    src={image}
                    alt="phot_user"
                />
                <h6 className={styles.cardPeoplesName}>{name}</h6>
                <p className={styles.cardPeoplesOcupation}>{ocupation}</p>
                <Button
                    icon={images.plus}
                    alignImg="left"
                    classs="btnMain"
                    text="Follow"
                    onClick={onClick}
                />
            </div>
        </>
    );
};

CardPeoples.propTypes = {
    image: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    ocupation: PropTypes.string.isRequired,
    onClick: PropTypes.any
};

export default CardPeoples;
